import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPromotionsByGenre } from "features/Top/topSlice";
import { SERVICE, LIMIT } from "constants/global";
import { scroolElement } from "utils/common";
import { Pagination } from "components";
import CardItem from "../CardItem";
import ErrorDB from "components/ErrorDB";

const TabPanel = ({ isTabActive, index, isInLine }) => {
  const dispatch = useDispatch();

  const { promotion_all, genre_init, promotion_genre } = useSelector(
    (state) => state.top
  );

  // set genre display
  const [currentPage, setCurrentPage] = useState(1);
  const [genre, setGenre] = useState(
    index > -1 ? genre_init[index] : promotion_all
  );

  const handleLoadPage = (currentPage) => {
    setCurrentPage(currentPage);
    dispatch(
      getPromotionsByGenre({
        genre: index > -1 ? index : null,
        currentPage: currentPage,
        service: SERVICE,
        limit: LIMIT,
      })
    );
    scroolElement(".tabs-background", 100);
  };

  // cập nhật lại genre sau khi call API
  useEffect(() => {
    if (isTabActive && promotion_genre) {
      setGenre(promotion_genre);
    }
  }, [promotion_genre]);

  return (
    isTabActive && (
      <div className="tab-panel active">
        {isInLine && <ErrorDB/>}
        <div>
          {genre?.data?.length > 0 &&
            genre?.data?.map((item) => <CardItem key={item.id} item={item} />)}
        </div>

        {genre?.last_page > 1 && (
          <Pagination
            pages={genre.last_page}
            currentPage={currentPage}
            padding={false}
            top={true}
            handle={handleLoadPage}
          />
        )}
      </div>
    )
  );
};

export default TabPanel;
